<nz-page-header title="Възстановяване на парола"/>
<section class="mb-5 container-lg">
  <div class="row justify-content-center">
    <div class="col-12 col-md-8 col-xl-6">
      <div class="px-3 border rounded-3 shadow bg-light">
        <header class="py-4 mb-4 border-bottom d-flex align-items-center gap-3">
          <nz-logo height="50"/>
          <h1 class="text-muted">Collectoria</h1>
        </header>
        <main>
          <form [formGroup]="form">
            <fieldset class="mb-4">
              <label for="password" class="mb-0 form-label">Парола*</label>
              <input
                id="password"
                type="password"
                minlength="8"
                formControlName="password"
                class="form-control"
                placeholder="Въведете парола..."
                aria-label="Парола"
                [class.is-valid]="password?.touched && password?.valid"
                [class.is-invalid]="password?.touched && password?.invalid">
              <p class="invalid-feedback m-0">Задължително поле с минимална дължина от 8 символа!</p>
            </fieldset>
            <fieldset class="mb-4">
              <label for="confirmPassword" class="mb-0 form-label">Повторете паролата*</label>
              <input
                id="confirmPassword"
                type="password"
                minlength="8"
                formControlName="confirmPassword"
                class="form-control"
                placeholder="Повторете паролата..."
                aria-label="Повторете паролата"
                [class.is-valid]="confirmPassword?.touched && confirmPassword?.valid && confirmPassword?.value === password?.value"
                [class.is-invalid]="confirmPassword?.touched && (confirmPassword?.invalid || confirmPassword?.value !== password?.value)">
              @if (confirmPassword?.touched && !confirmPassword?.valid) {
                <div class="text-danger">
                  <small>Задължително поле с минимална дължина от 8 символа!</small>
                </div>
              }
              @if (confirmPassword?.touched && confirmPassword?.value !== password?.value) {
                <div class="text-danger">
                  <small>Паролата не съвпада!</small>
                </div>
              }
            </fieldset>
          </form>
          @if (!!errorMessage) {
            <div class="pb-4 text-danger">
              {{ errorMessage }}
            </div>
          }
          <button
            (click)="onSubmit()"
            [disabled]="loading"
            class="w-100 mb-4 btn btn-nz-primary">
            @if (loading) {
              <span class="me-2 spinner-border spinner-border-sm"></span>
            }
            <span>Възстановяване</span>
          </button>
        </main>
        <footer class="mb-3 pt-3 d-flex justify-content-between border-top">
          <a aria-label="Вход"
             class="btn btn-link text-decoration-none"
             [routerLink]="[appRoutes.root, appRoutes.account, appRoutes.login]">
            Вход
          </a>
          <a aria-label="Забравена парола"
             class="btn btn-link text-decoration-none"
             [routerLink]="[appRoutes.root, appRoutes.account, appRoutes.registration]">
            Регистрация
          </a>
        </footer>
      </div>
    </div>
  </div>
</section>
